import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface RongdataEducationalInformationOverviewProps {
  educationList: any[]
}

const educationMap: Record<string, string> = {
  '11': '博士研究生',
  '14': '硕士研究生',
  '20': '本科',
  '30': '专科',
}

const educationLevel: Record<string, number> = {
  '11': 4,
  '14': 3,
  '20': 2,
  '30': 1,
}

export default function RongdataEducationalInformationOverview({
  educationList,
}: RongdataEducationalInformationOverviewProps) {
  const theme = useTheme()
  const totalRecords = educationList.length

  const getHighestEducation = () => {
    if (educationList.length === 0) return '—'
    let highestCode = ''
    let highestLevel = 0

    educationList.forEach((item: any) => {
      const code = item?.xldm
      const level = educationLevel[code] || 0
      if (level > highestLevel) {
        highestLevel = level
        highestCode = code
      }
    })

    return educationMap[highestCode] || highestCode || '—'
  }

  const getEarliestEnrollmentYear = () => {
    if (educationList.length === 0) return '—'
    const years = educationList
      .map((item: any) => item?.rxnf)
      .filter((year: string) => year && year !== '')
      .sort()
    return years.length > 0 ? years[0] : '—'
  }

  const highestEducation = getHighestEducation()
  const earliestYear = getEarliestEnrollmentYear()

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            教育信息概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总教育经历的整体情况,包括记录数量、最高学历及最早入学时间。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="教育记录数" value={`${totalRecords} 条`} subtitle="教育经历总数" />
          <SummaryItem label="最高学历" value={highestEducation} subtitle="已获得最高学历" />
          <SummaryItem label="最早入学年份" value={earliestYear} subtitle="首次接受高等教育" />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
